<template>
  <div class="listingSection">
    <router-link
      v-if="titleLink.length > 0"
      :to="titleLink"
    >
      <h1 class="collectionTitle">{{sectionTitle}}</h1>
    </router-link>
    <h1 v-else class="collectionTitle">
      {{sectionTitle}}
    </h1>
    <div v-if="textSection.length > 0" class="sectionText">
      {{ textSection }}
    </div>
    <div v-if="textBanner.length > 0" class="textBanner" :style="`background-color: ${bannerBackground}`">
      {{ textBanner }}
    </div>
    <ais-index
      class="listingContainer"
      :index-name="computedAlgoliaIndex"
    >
      <Listing
        :collection="collection"
        :ignoreVeganFlag="!showVeganItemsOnly"
        :displayModal="displayModal"
        :displayTags="displayTags"
        :tag="tag"
        :horizontal="horizontal"
        :itemType="itemType"
        :userLogged="$store.getters.userLoggedIn"
        :perPage="perPage"
        :infinite="infinite"
        :promotedOrgOfferings="['org_5ZfxxqrlbODXf5AO', 'org_dt7FOOwX6sjeat5k']"
        :disabledCollections="['vk_icecream']"
        @addItemToCart="$emit('addItemToCart', $event)"
        @openSnackbar="$emit('openSnackbar', $event)"
      />
    </ais-index>
  </div>
</template>

<script>

export default {
  name: 'ListingSection',
  data () {
    return {
      algoliaIndex: process.env.VUE_APP_ALGOLIA_INDEX
    }
  },
  props: {
    sectionTitle: {
      type: String,
      required: false,
      default: ''
    },
    titleLink: {
      type: String,
      required: false,
      default: ''
    },
    textSection: {
      type: String,
      required: false,
      default: ''
    },
    textBanner: {
      type: String,
      required: false,
      default: ''
    },
    bannerBackground: {
      type: String,
      required: false,
      default: '#FFFFFF'
    },
    collection: {
      type: String,
      required: false,
      default: ''
    },
    ignoreVeganFlag: {
      type: Boolean,
      required: false,
      default: false
    },
    displayModal: {
      type: Boolean,
      required: false,
      default: true
    },
    displayTags: {
      type: Boolean,
      required: false,
      default: false
    },
    tag: {
      type: String,
      required: false,
      default: null
    },
    horizontal: {
      type: Boolean,
      required: false,
      default: false
    },
    itemType: {
      type: String,
      required: false,
      default: 'packagedfood'
    },
    perPage: {
      type: Number,
      required: false,
      default: 5
    },
    infinite: {
      type: Boolean,
      required: false,
      default: false
    },
    sortByNewest: {
      type: Boolean,
      required: false,
      default: false
    },
    algoliaIndexSuffix: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    isVeganKindRoute () {
      return this.$route.path.includes('vegankind')
    },
    isRecipesRoute () {
      return this.$route.path.includes('/recipes')
    },
    userData () {
      return this.$store.state.userData
    },
    veganUser () {
      if (this.userData.attrs !== undefined &&
        this.userData.attrs !== null &&
        this.userData.attrs.vegan_only !== null &&
        this.userData.attrs.vegan_only !== undefined) {
        return this.userData.attrs.vegan_only
      }
      // By Default, user is not considered "Vegan"
      return false
    },
    showVeganItemsOnly () {
      // Show on Recipes page
      // General marketplace now
      if (this.ignoreVeganFlag || this.isRecipesRoute) return false
      // Return true if we want to show only vegan items
      if (this.veganUser || this.isVeganKindRoute) return true
      // ? We probably don't need this ignoreVeganFlag as it's a
      // By Default show all items
      return false
    },
    computedAlgoliaIndex () {
      if (this.algoliaIndexSuffix !== null) return `${this.algoliaIndex}${this.algoliaIndexSuffix}`
      return this.sortByNewest ? `${this.algoliaIndex}_new_to_old` : this.algoliaIndex
    }

  }
}
</script>

<style scoped lang="stylus">
.listingSection {
  .listingContainer {
    min-height: 168px;
  }
  .collectionTitle {
    margin-top: 30px;
    font-family: 'Bebas Neue', sans-serif;
  }
  .textBanner {
    padding: 5px 10px;
    margin: 0px 0px 20px 0px;
    border-radius: 5px;
  }
  .sectionText {
    padding: 0px 0px 30px 0px;
    color:black

    .bebasNeue {
      font-family: 'Bebas Neue', sans-serif;
    }
  }
}
</style>
